import { Page } from '@/common/models/page';

export const EmployeeReviewProcessData = function () {
    this.employees  = new Page();
    this.managers   = new Page();
};
